export default __webpack_public_path__ + "static/Entenda0132-566f98051a8145f6f48a475737d89bbe.jpg";